import createApolloClient from 'graphql-client';

import {
    PRODUCT_WIDGET,
    PRODUCT_WIDGET_FAILURE,
    PRODUCT_WIDGET_SUCCESS,
} from 'ggApp/modules/productWidget/constants';
import CookiesManager from 'ggApp/utils/CookiesManager';

import GetProductsWidgets from './getProductsWidgets.graphql';

export function getProductWidgets(params, location, req) {
    return (dispatch) => {
        const apolloClient = createApolloClient(new CookiesManager(req));
        dispatch({
            type: PRODUCT_WIDGET,
        });
        return apolloClient
            .query({
                query: GetProductsWidgets,
                variables: {
                    where: {
                        active: true,
                        storeCode: params.store,
                    },
                },
            })
            .then((response) => {
                const { productsWidgets } = response?.data;
                dispatch({
                    type: PRODUCT_WIDGET_SUCCESS,
                    data: productsWidgets.rows,
                });
            })
            .catch((error) =>
                dispatch({
                    type: PRODUCT_WIDGET_FAILURE,
                    error,
                }),
            );
    };
}
